import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import WarningSpan from '@/common/components/WarningSpan';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import SearchBox from './components/SearchBox';
import { TABLE_HEADERS } from './constants/table';
import { getTableRows } from './helpers/getTableRows';
import useMailReport from './hooks/useMailReport';
import useSearchBox from './hooks/useSearchBox';

const MailsReport = () => {
	const hook = useMailReport();
	const searchBoxHook = useSearchBox(hook.fetchMailTemplateStats);

	return (
		<>
			{(hook.isLoading || searchBoxHook.isLoading) && <Loading />}
			<WrapperWithScroll>
				<WarningSpan>
					Caution: Data in this table prior to 2025-03-07 could be incomplete or
					inaccurate.
				</WarningSpan>

				<SearchBox hook={searchBoxHook} />

				{hook.displayedRows && (
					<Table
						className='styled-table'
						raws={getTableRows(hook.displayedRows)}
						headers={TABLE_HEADERS}
					/>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default MailsReport;
